<template>
    <modal
            :linkClass="'action-icon'"
            :modalId="name"
            :title="title"
            :modalSize="'large'"
            :footer="true"
    >
        <template slot="modalBody">
            <div class="row">
                <div class="col-6">
                    <div class="form-group">
                        <label :for="name+'-department'">Status</label>
                        <select v-validate="'required'"
                                :name="name+'-name'"
                                :id="name+'-name'"
                                type="text"
                                class="form-control"
                                value="Leave Request"
                                v-model="leaveRequest.status"
                        >
                            <option v-for="option, key in options" v-bind:value="option" v-bind:key="key">
                                {{ option }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label :for="name+'-department'">Date</label>
                        <input type="text" disabled v-model="dateFormatted" class="form-control">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <textarea v-model="leaveRequest.reason" style="width: 100%" placeholder="No reason..." rows="6" disabled>
                        </textarea>
                    </div>
                </div>
            </div>
            <hr/>
            <div class="row">
                <div class="col-12">
                    <label :for="name+'-textarea'">Add comment</label>
                </div>
                <div class="col-12">
                    <textarea :id="name+'-textarea'" v-model="comment" style="width: 100%" rows="4">
                    </textarea>
                </div>
            </div>
            <!-- <div class="form-group">
                <div v-for="flexworker, key in flexworkers" v-bind:key="key">
                    <input type="checkbox" :id="key + '-flexworker'" :value="flexworker.id" v-model="selectedFlexworkers"/> <label v-bind:for="key + '-flexworker'" style="margin-left: 5px">{{flexworker.name}}</label>
                </div>
            </div> -->
        </template>
        

        <div class="modal-footer" slot="modalFooter">
            <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">
                Cancel
            </button>
            <button type="button" class="btn btn-primary" @click="updateLeaveRequest" data-dismiss="modal">
                <i class="fal fa-save mr-2"></i> Update Request
            </button>

        </div>
    </modal>
</template>

<script>
    import Vue from 'vue';
    import {mapGetters} from 'vuex';
    import 'vue-multi-select/dist/lib/vue-multi-select.css';
    import store from '../../store.js';

    export default {
        data() {
            return {
                comment: '',
                options: ['pending', 'approved', 'rejected']
            };
        },
        async   created() {
            let employment = this.getEmployment

            if(employment !== null && employment.organization !== undefined) {
                this.organization = employment.organization.id
                store.dispatch('flexworkers/getAll', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments, employment_id: this.id}).then((res) => {
                    if (res.status === 200) {
                        this.flexworkers = res.data.data
                    }
                }).catch((err) => {
                    console.log(err)
                    alert('Unexpected error downloading employments')
                });   
            }
        },
        props: ['index', 'title', 'value', 'name', 'leaveRequest'],
        methods: {
            updateLeaveRequest() {
                this.$emit('saveChanges', this.leaveRequest);
            },
        },
        components: {
        },
        computed: {
            ...mapGetters('employments', [
                'getEmployment'
            ]),
            dateFormatted: {
                get () {
                    return moment(this.leaveRequest.created_at, "YYYY-MM-DD").format('DD/MM/YYYY') + ' (' + this.leaveRequest.hours + ' hours)'
                }, 
                set (value) {
                    this.leaveRequest.created_at = value
                }
            }
        },
        watch: {
        }
    }
</script>

<style lang="scss">
@import "../../assets/scss/modal.scss";
</style>